<template>
	<ListDetailLayout
			:store="usersStore"
      index-route-name="admin.users"
			create-permissions="create:users"
			@on-create="$router.push({ name: 'admin.users.user', params: { user: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshUsers, params)"
			@on-search="(page) => useOnSearch(page, refreshUsers, params)"
      :filter="params.filter"
      @on-filter="({ filter }) => useOnFilter(filter, refreshUsers, params)"
	>

		<template #list>
			<li v-for="user in usersStore.getUsers" :key="user.id">
				<router-link
						:to="{ name: $route.name.startsWith('admin.users.user') ? $route.name : 'admin.users.user', params: { user: user.id } }"
						v-slot="{isActive}">
					<div
							:class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0 flex flex-row w-full items-center justify-between">
							<div class="flex-1">
								<div class="flex items-start gap-x-3">
									<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ user.name }} 
										<span :title="user.two_factor_enabled ? '2FA Enabled' : '2FA Disabled'">
											 <IconLockCheck class="inline-block w-4 h-4 text-green-800" v-if="user.two_factor_enabled" />
											<IconLockOff class="inline-block w-4 h-4 text-red-800" v-if="!user.two_factor_enabled" />
										</span>
									</p>
								</div>
								<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
									<p class="whitespace-nowrap">
										{{ user.email }}
									</p>
								</div>
							</div>
							<!--							<div class="text-sm text-gray-600">{{ fileSize(user.size_bytes) }}</div>-->

              <div class="flex flex-col items-center space-y-1">
                <IconAlertTriangleFilled v-if="user.companies_count === 0" class="text-yellow-400 h-5 w-5"/>
              </div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
			<router-view v-if="$route.params.user" @on-save="refreshUsers()"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useUsersStore } from "@/stores/users.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";
import {IconAlertTriangleFilled} from "@tabler/icons-vue";
import { IconLockCheck, IconLockOff } from '@tabler/icons-vue';

export default {
	name: "UserIndex",
	data() {
		return {
			params: {
        include: [
            'companiesCount',
        ],
        filter: {
          company_ids: [],
          role_ids: [],
        }
      }
		}
	},
	methods: {
    useOnFilter,
		useOnSearch,
		useOnPaginate,
		refreshUsers() {
			return this.usersStore.indexUsers(this.params);
		}
	},
	components: {IconAlertTriangleFilled, Container, ListDetailLayout, IconLockCheck, IconLockOff},
	computed: {
		...mapStores(useUsersStore)
	},
	async mounted() {
		await this.refreshUsers()
	}
}
</script>